import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

const useStyle = makeStyles({
	skeletonContainer: {
		display: 'flex',
		flexDirection: 'column',
		...shorthands.gap('8px'),
		width: '150px',
	},
	skeletonRule: {
		alignItems: 'center',
		display: 'grid',
		paddingBottom: '10px',
		position: 'relative',
		...shorthands.gap('10px'),
		gridTemplateColumns: 'min-content 80%',
	},
	skeletonDescription: {
		display: 'flex',
		...shorthands.gap('8px'),
		...shorthands.margin(0, 0, 0, '24px'),
	},
	showMore: {
		color: tokens.colorBrandBackground,
		fontWeight: tokens.fontSizeBase500,
	},
	showMoreError: {
		color: tokens.colorPaletteRedBackground3,
		fontWeight: tokens.fontSizeBase500,
	},
	textOverflowHidden: {
		'& .fui-TreeItemLayout__main': {
			...shorthands.overflow('hidden'),
			maxWidth: '100%',
			textOverflow: 'ellipsis',
		},
	},
	hover: {
		':hover': {
			'::before': {
				backgroundColor: tokens.colorNeutralStroke1Hover,
				borderTopLeftRadius: tokens.borderRadiusMedium,
				content: '""',
				width: '4px',
				position: 'absolute',
				left: 0,
				height: '30px',
				...shorthands.margin(0, '10px', 0, 0),
			},
		},
	},
	selectedItem: {
		'backgroundColor': tokens.colorNeutralBackground1Selected,
		'::before': {
			backgroundColor: tokens.colorBrandBackground,
			borderTopLeftRadius: tokens.borderRadiusMedium,
			content: '""',
			width: '4px',
			position: 'absolute',
			left: 0,
			height: '30px',
			...shorthands.margin(0, '10px', 0, 0),
		},
	},
});

export default useStyle;
